import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { UrlParams, PaginatedTaxRateList } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface QueryKeyType {
  pageParam?: UrlParams;
  queryKey: (string | undefined)[];
}

interface IUseTaxRates {
  search?: string;
  ordering?: string;
}

function useTaxRates({
  search,
  ordering,
}: IUseTaxRates): UseInfiniteQueryResult<AxiosResponse<PaginatedTaxRateList>> {
  const fetchTaxRates = ({
    pageParam = { limit: '20', offset: '0' },
  }: QueryKeyType): Promise<AxiosResponse<PaginatedTaxRateList>> => {
    const params = pageParam;

    if (search) {
      params.search = search;
    }

    if (ordering) {
      params.ordering = ordering.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`).concat(',pk');
    }

    return client.get(`tax-rates/?${encodeUrlParams(params)}`);
  };

  return useInfiniteQuery(['taxRates', search, ordering], fetchTaxRates, {
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
  });
}

export default useTaxRates;
